import "@fontsource-variable/inter";
import "@fontsource-variable/space-grotesk";
import "@fontsource-variable/jetbrains-mono/wght.css"
import "@fortawesome/fontawesome-free/css/all.css"


import 'bootstrap/dist/css/bootstrap.min.css';
import "$styles/index.css";
import "$styles/syntax-highlighting.css";

import * as bootstrap from 'bootstrap';


// Import all JavaScript & CSS files from src/_components
import components from "$components/**/*.{js,jsx,js.rb,css}";

console.info("Bridgetown is loaded!");
